import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Typography } from '../Typography/Typography';
import { useClassName } from '../../hooks';
import './TextButton.scss';
/**
 * TextButton component is used to render a button with text.
 */
export const TextButton = ({ children, disabled = false, onClick: callback, testId }) => {
    const className = useClassName({ name: 'text-button', prefixed: true });
    const color = useMemo(() => (disabled ? 'neutral-300' : 'primary-500'), [disabled]);
    const onClick = useCallback(() => (disabled ? undefined : callback()), [callback, disabled]);
    return (_jsx("div", { "data-testid": testId, className: className, onClick: onClick, children: _jsx(Typography.Text, { whiteSpace: 'nowrap', size: 'sm', weight: 'semi-bold', pointerEvents: 'none', color: color, children: children }) }));
};
